<template>
    <div class="container">
        <div class="view">
            <div class="header">
                <div class="title">
                    {{prescription.createOrganName}} <br />
                    处方笺
                </div>
                <div class="watermark">普通<br />处方</div>
            </div>

            <div class="info">
                <van-row class="row">
                    <van-col span="24" class="title">
                        NO：{{ prescription.id }}
                    </van-col>
                </van-row>
                <van-row class="row">
                    <van-col span="12" class="title">
                        患者姓名：{{ prescription.patientName }}
                    </van-col>
                    <van-col span="12" class="title">
                        性别：{{ prescription.gender }}
                    </van-col>
                </van-row>
                <van-row class="row">
                    <van-col span="12" class="title">
                        年龄：{{ prescription.age }}
                    </van-col>
                    <van-col span="12" class="title">
                        费别：{{ prescription.feeTypeName }}
                    </van-col>
                </van-row>
                <van-row class="row">
                    <van-col span="12" class="title">
                        联系电话：{{ prescription.phone }}
                    </van-col>
                </van-row>
                <van-row class="row">
                    <van-col span="24" class="title">
                        开单日期：{{ prescription.createTime }}
                    </van-col>
                </van-row>
                <van-row class="row">
                    <van-col span="12" class="title">
                        开单医生：{{ prescription.createUserName }}
                    </van-col>
                    <van-col span="12" class="title">
                        开单科室：{{ prescription.createDepartmentName }}
                    </van-col>
                </van-row>
                <van-row class="row">
                    <van-col span="24" class="title">
                        初步诊断：{{ prescription.diagnosis }}
                    </van-col>
                </van-row>
            </div>

            <div class="content">
                <div class="icon">℞</div>
                <div
                    class="item"
                    v-for="(item, index) in prescription.list"
                    :key="index"
                >
                    <div>
                        <div>
                            <span>{{ item.orderItemName }}</span>
                        </div>
                    </div>
                    <div>
                        <div>
                            <span>{{ item.specs }}</span>
                            <span>×</span>
                            <span>{{ item.amount }}{{ item.unit }}</span>
                        </div>
                        <div>
                            <span>{{ item.totalFee }}元</span>
                        </div>
                    </div>
                    <div>
                        <div>
                            <span>{{ item.usageName }}</span>
                            <span>{{ item.frequencyName }}</span>
                            <span>每次</span>
                            <span
                                >{{ item.singleDose }}{{ item.doseUnit }}</span
                            >
                        </div>
                    </div>
                </div>
                <van-divider />
            </div>

            <div class="footer">
                <div>金额（元）：{{ prescription.totalFee }}</div>
            </div>

            <div class="footer">
                <div>
                    医师签名：
                    <img
                        class="signed-image"
                        :src="prescription.doctorSignedImgUrl"
                    />
                </div>
                <div>
                    审核签名：
                    <img
                        class="signed-image"
                        :src="prescription.pharmacistSignedImgUrl"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import manageApi from '@/api/manageApi';

export default {
    data() {
        return {
            prescription: {}
        };
    },
    created() {
        manageApi.viewPrescription(this.prescriptionId).then(res => {
            this.prescription = res.data;
        });
    },
    methods: {
    },
    props: {
        prescriptionId: {
            type: String,
            required: true
        }
    }
}
</script>


<style lang="less" scoped>
.container {
    .view {
        border-radius: 0.133333rem;
        margin: 0.266667rem 0.2rem;
        padding: 0.533333rem 0.266667rem;
        background-color: @white-color;
        color: @black-color;
        position: relative;
        box-shadow: 0.08rem 0.08rem 0.106667rem rgba(26, 26, 26, 0.1);

        .header {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            margin-bottom: 0.4rem;

            .title {
                font-size: 0.426667rem;
                font-weight: bold;
                text-align: center;
            }
        }

        .watermark {
            position: absolute;
            right: 0.266667rem;
            font-size: 0.373333rem;
            font-weight: bold;
            padding: 0 0.133333rem;
            border-radius: 0.026667rem;
            color: #d0d0d0;
            border: 0.053333rem solid #d0d0d0;
        }

        .info {
            padding-top: 0.133333rem;

            .row {
                font-size: 0.32rem;
                position: relative;
                padding: 0.133333rem 0;
                line-height: 0.4rem;
                margin-bottom: 0.1rem;
            }
        }

        .content {
            .icon {
                font-size: 0.693333rem;
                font-weight: bold;
            }

            .item {
                font-size: 0.32rem;
                margin-bottom: 0.266667rem;
                line-height: 0.6rem;
                > div {
                    display: flex;
                    justify-content: space-between;
                    > div > span:not(:last-child) {
                        margin-right: 0.213333rem;
                    }
                }
            }
        }

        .footer {
            font-size: 0.32rem;
            display: flex;
            justify-content: space-between;
            line-height: 0.8rem;
            > div {
                flex: 1;
                display: flex;
                align-items: center;

                .signed-image {
                    width: 2.4rem;
                    height: 0.6rem;
                }
            }
        }
    }
}
</style>